import { Global } from "@/utils/global";
import Phaser from "phaser";

//Game config
export const GameConfig = {
    type: Phaser.CANVAS,
    backgroundColor: '#000000',
    resolution: window.devicePixelRatio,
    scale: {
        autoCenter: Phaser.Scale.CENTER_BOTH,
        mode: Phaser.Scale.NONE,
        width: window.innerWidth,
        height: window.innerHeight,
    },
    dom: {
        createContainer: true
    }, 
    physics: {
        default: 'arcade',
        arcade: {
            gravity: {
                y: 0
            },
            debug: false,
        }
    },
    autoRound:true,
}